import { CbhIcon } from "@clipboard-health/ui-components";
import { Stack } from "@mui/material";

interface AddFileTileProps {
  onClick: () => void;
}

export function AddFileTile(props: AddFileTileProps) {
  const { onClick } = props;

  return (
    <Stack
      component="button"
      type="button"
      aria-label="Add file"
      sx={(theme) => ({
        aspectRatio: "1",
        width: "100%",
        border: `${theme.borderWidth.thick} dashed ${theme.palette.border?.primary ?? theme.palette.divider}`,
        borderRadius: theme.shape.borderRadius,
        alignItems: "center",
        justifyContent: "center",
        backgroundColor: "transparent",
        "&:hover": {
          backgroundColor: theme.palette.action.hover,
        },
        "&:active": {
          backgroundColor: theme.palette.action.selected,
        },
      })}
      onClick={onClick}
    >
      <CbhIcon type="document-plus" size="large" />
    </Stack>
  );
}
